import { computed, ref, toValue } from 'vue';
import CardsAPI from 'custom/dashboard/api/cards';

// Shared across callers, so the sidebar switch's badge and the cards panel read the same list.
const cardsByConversation = ref({});

export function useConversationCards(conversationId) {
  const isLoaded = computed(
    () => toValue(conversationId) in cardsByConversation.value
  );
  const cards = computed(
    () => cardsByConversation.value[toValue(conversationId)] || []
  );
  const openCount = computed(
    () => cards.value.filter(card => card.status === 'open').length
  );

  const fetchCards = async () => {
    const id = toValue(conversationId);
    const allCards = [];
    let page = 1;
    let data;
    do {
      // Each response supplies the total used to decide whether another page is needed.
      // eslint-disable-next-line no-await-in-loop
      ({ data } = await CardsAPI.getByConversation(id, page));
      allCards.push(...data.payload);
      page += 1;
    } while (data.payload.length && allCards.length < data.meta.count);
    cardsByConversation.value = {
      ...cardsByConversation.value,
      [id]: allCards,
    };
  };

  return { cards, isLoaded, openCount, fetchCards };
}
